module.exports = __webpack_public_path__ + "static/media/grass.2d65b860.svg";